import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = { class: "\n          d-flex\n          flex-wrap-reverse\n          align-items-end\n          justify-content-between\n          text-nowrap\n        " }
const _hoisted_3 = { class: "flex-column me-4" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createVNode("strong", null, "Type:", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("strong", null, "Level: ", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("strong", null, "Timestamp (UTC):", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("strong", null, "Event:", -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createVNode("strong", null, "User:", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("strong", null, "Organization:", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("strong", null, "Application:", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("strong", null, "IP Address:", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("strong", null, "Machine Name:", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("h5", null, "Message", -1)
const _hoisted_22 = {
  class: "p-3 bg-light rounded overflow-auto",
  style: {"height":"40vh","word-wrap":"break-word","white-space":"pre-wrap"}
}
const _hoisted_23 = { style: {"white-space":"pre-wrap","word-wrap":"break-word"} }
const _hoisted_24 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("h5", null, "Exception", -1)
const _hoisted_26 = {
  class: "p-3 bg-light rounded overflow-auto",
  style: {"height":"25vh","min-height":"150px"}
}
const _hoisted_27 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("h5", null, "Revision Data", -1)
const _hoisted_29 = {
  class: "p-3 bg-light rounded overflow-auto",
  style: {"height":"40vh","word-wrap":"break-word","white-space":"pre-wrap"}
}
const _hoisted_30 = { style: {"white-space":"pre-wrap","word-wrap":"break-word"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pretty_bar = _resolveComponent("pretty-bar")!
  const _component_NewSidebar = _resolveComponent("NewSidebar")!

  return (_openBlock(), _createBlock(_component_NewSidebar, {
    isLoading: _ctx.loading,
    ref: "sidebarRef",
    error: _ctx.error,
    class: "d-flex flex-column bg-white",
    onOnHiding: _ctx.handleHideSidebar
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_pretty_bar),
            _createVNode("h2", null, _toDisplayString(_ctx.getLogLevelText(_ctx.log?.level)), 1)
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("p", null, [
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(_ctx.log.type), 1)
                  ]),
                  _createVNode("p", null, [
                    _hoisted_10,
                    _createVNode("span", {
                      class: {
                      'text-danger': _ctx.log.level === 'ERROR',
                      'text-warning': _ctx.log.level === 'WARNING',
                      'text-info': _ctx.log.level === 'INFO',
                    }
                    }, _toDisplayString(_ctx.log.level), 3)
                  ]),
                  _createVNode("p", null, [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_ctx.displayUTCTimestamp(_ctx.log.timestamp)), 1)
                  ]),
                  _createVNode("p", null, [
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(_ctx.log.eventDescription), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode("p", null, [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.log.userInfo || "-"), 1)
                  ]),
                  _createVNode("p", null, [
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString(_ctx.log.organizationName || "-"), 1)
                  ]),
                  _createVNode("p", null, [
                    _hoisted_16,
                    _createTextVNode(" " + _toDisplayString(_ctx.log.applicationName || "-"), 1)
                  ]),
                  _createVNode("p", null, [
                    _hoisted_17,
                    _createTextVNode(" " + _toDisplayString(_ctx.log.ipAddress), 1)
                  ]),
                  _createVNode("p", null, [
                    _hoisted_18,
                    _createTextVNode(" " + _toDisplayString(_ctx.log.machineName), 1)
                  ])
                ])
              ]),
              _hoisted_19,
              (_ctx.log.message)
                ? (_openBlock(), _createBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode("div", _hoisted_22, [
                      _createVNode("pre", _hoisted_23, _toDisplayString(_ctx.formatLogMessage(_ctx.log.message, _ctx.log.timestamp)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.log.exception)
                ? (_openBlock(), _createBlock("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode("div", _hoisted_26, [
                      _createVNode("pre", null, _toDisplayString(_ctx.log.exception), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.log.revisionData)
                ? (_openBlock(), _createBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode("div", _hoisted_29, [
                      _createVNode("pre", _hoisted_30, _toDisplayString(_ctx.formatJson(_ctx.log.revisionData)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["isLoading", "error", "onOnHiding"]))
}